export const MULTI_TABS_DEFAULT_STATE = {
    activeTabs: [],
    isTourDismissed: false
};
